import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { MenuOutlined,  PlusCircleFilled , MinusCircleFilled, CloseSquareOutlined, EditFilled, EditTwoTone, EditOutlined, ArrowLeftOutlined} from '@ant-design/icons';
import { Button, Drawer, Form, Input, Menu, Popconfirm, Switch } from 'antd';
import { menu } from './Dash';
import { addStoreFunction, checkLogIn, getEnterpriseInfo, getStore, messageGeneral, removeStore } from './Functions';
import { useForm } from 'antd/es/form/Form';



function Company() {
  const navigate = useNavigate();
  const [addStore, setAddStore] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [openDrawer, setOpenDrawer]   = useState(false)
  const [ stores, setStores]    = useState([])
  const [context, start ]                         = messageGeneral();
  const [form] = useForm()

  const [edit, setEdit] = useState(null)
  useEffect(()=>{
    if( edit == null) return;
    form.setFieldValue('name', edit.name);
  },[edit])



    async function callStores( ) {
      setStores( await getStore(true) );
    }

    useEffect(() => {
      if( checkLogIn() == null ) navigate('/');
      if( getEnterpriseInfo().role == 'operator') navigate('/movements')
      callStores()
    },[])

    const Conferma = ( child, token ) => {
    
      async function remove() {
       const r = await removeStore(token);
       if( r ){
        start('Azienda eliminato')
        callStores()
       }
      }
    
      return (
        <Popconfirm
          title="Sei sicuro di voler eliminare?"
          onConfirm={()=> remove()}
          okText="Sì"
          cancelText="No"
        >
          { child }
        </Popconfirm>
      );
    };


  async function register  ( values ){
    try{
      const { name } = values;
      const add = await addStoreFunction(name, (edit != null ? edit.token : null), 1 );
      if( add ){
        if( edit ){
          await callStores()
          start('Azienda Modificata')
          form.resetFields()
          setAddStore(false)
          setEdit(null)
          return;
        }
        start('Azienda aggiunta')
        form.resetFields()
      }

    }catch( err ){
      console.log(err);
    }
  }


  return (
    <div className="center bg-color-primary all-viewport">
      {context}
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
      </div>
      <div style={{position:'fixed', top: '10px', right:'10px'}}>
        {
          addStore 
          ?
          < ArrowLeftOutlined onClick={() =>  {setAddStore(false); callStores(); form.resetFields(); setEdit(null)}} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
          :
          < PlusCircleFilled  onClick={() =>  setAddStore(true)} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
        }
      </div>
      <div className='table-smart' style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
 <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'20px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )
          }
        </div>
      </Drawer> 
       {
       addStore
       ?   
        <Form
            form={form}
            onFinish={register}
          >
            <div className='center text-style' style={{ marginBottom:'10px'}}>{edit ? 'Modifica azienda' : 'Aggiungi azienda'} </div>
            <Form.Item
                name="name"
                rules={[{ required: true, message: 'Inserire nome azienda' }]}
              >
                <Input className='input-style' placeholder='Nome azienda'/>
            </Form.Item>

            <Button
              className='input-style color-one'
              type="primary" 
              htmlType="submit">
              { !edit ? 'Aggiungi' : 'Modifica' }</Button>
          </Form>
          :
          <div  style={{ height:'100%', width:'100%', backgroundColor:''}} className='center'> 
          <div className='center' style={{ height:'70%', width:'80%', backgroundColor:'', flexDirection:'column'}}>
            <div className='center text-style' style={{ marginBottom:'10px'}}> Lista aziende </div>
            <div style={{width:'100%', maxWidth:'500px', height: '100%', overflowY:'auto', backgroundColor:'', marginTop:'20px'}}>
              {
                stores.map((s, index) => {
                  return (
                  <div className='center' style={{ padding:'10px', textAlign:'center', backgroundColor: (index %2 == 0) ?  'rgba(52, 121, 57, 0.5)' : 'rgba(52, 121, 57, 0.2)'   }}>
                        <div className='center' style={{ width:'100%', height:'40px', justifyContent:'flex-start'}} key={index}> { s.businessName } </div>
                        { Conferma(<CloseSquareOutlined  style={{color:'red', fontSize:'25px'}} />, s.token) }
                        <div style={{width:'20px'}}/>
                        { <EditOutlined onClick={()=>{
                          setEdit(s)
                          setAddStore(true);
                        }}  style={{color:'rgba(52, 121, 57, 1)', fontSize:'25px', }} /> } 
                  </div>
                      )
                })
              }
            </div>
          </div>
        </div>
        }

    </div>
  );
}

export default Company;
